<div class="property-edit-container">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  @if (formLoading) {
  <div class="overlay">
    <div class="spinner-wrapper">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  }

  <form [formGroup]="form1" [class.blurred]="formLoading">
    <div class="container-fluid pt-2">
      <table style="width:100%">
        <tr>
          <td style="float:left">
            <h2>{{formLabels['title']}} {{form1?.value?.propertyCode}}</h2>
          </td>
          <td style="float:right;">
            <a href="https://www.kbmresorts.com/vacation-rentals/{{shortTermRentalId}}?preview=true" target="_blank"
              class="btn btn-orange btn-sm">Preview</a>
            <p-dropdown appendTo="body" [options]="properties" formControlName="shortTermRentalId"
              optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode"
              [showClear]="false" placeholder="Select Property" (onChange)="changeProperty($event)">
            </p-dropdown>

            <!--	<mat-form-field>
          <mat-label>select property</mat-label>

          <mat-select [(value)]="form1.value.shortTermRentalId" (selectionChange)="changeProperty($event)">
            <mat-option *ngFor="let property of properties" [value]="property.shortTermRentalId">
            {{property.propertyCode}} </mat-option>
          </mat-select>
          <mat-error *ngFor="let validation of validationMessages.listingStatus">
            <mat-error class="error-message" *ngIf="form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)">
            {{validation.message}}</mat-error>
          </mat-error>
        </mat-form-field>-->
          </td>
        </tr>
      </table>
    </div>

    <div class="container-fluid container-tab-main">
      <div class="property-edit-layout">
        <aside class="property-edit-sidebar">
          <nav class="property-left-nav" aria-label="Property sections">
            <div class="left-nav-search lazy-load-toolbar">
              <p-autoComplete [formControl]="navSearchCtrl" [suggestions]="navSearchSuggestions"
                (completeMethod)="filterNavSearch($event)" (onSelect)="onNavSearchSelect($event)" field="label"
                [dropdown]="true" [forceSelection]="true" [delay]="150" placeholder="Search sections"
                inputId="leftNavSearch">
                <ng-template pTemplate="item" let-item>
                  <div class="nav-search-item">
                    <span class="nav-search-label">{{ item.label }}</span>
                    @if (item.meta) {
                    <small class="nav-search-meta">{{ item.meta }}</small>
                    }
                  </div>
                </ng-template>
              </p-autoComplete>
            </div>
            <ul class="property-left-nav-list">
              @for (item of leftMenuItems; track item) {
              <li class="property-left-nav-item">
                <a [attr.href]="item.id ? '#' + item.id : '#'" [ngClass]="item.styleClass || 'left-nav-item'"
                  [class.left-nav-active]="!!item.id && activeSectionId === item.id"
                  (click)="onLeftNavClick($event, item)">
                  @if (item.icon) {
                  <i class="{{ item.icon }}"></i>
                  }
                  <span>{{ item.label }}</span>
                </a>
              </li>
              }
            </ul>
          </nav>
        </aside>

        <main class="property-edit-content">
          @if (!featureListsLoaded) {
          <div class="lazy-load-toolbar">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadAllFeatureLists()">
              Load all Feature Lists
            </button>
            <small class="text-muted ms-2">Feature lists are heavy; click to load them when you need
              them.</small>
          </div>
          }


          <section id="section-settings" class="jump-section">
            <h2 class="section-header">Settings</h2>

            <div id="section-settings-overview" class="settings-subsection">

              <h3 class="settings-subsection-title">Overview</h3>
              <div class="row m-0 mt-4">
                <div class="col-lg-12">
                  <h2 class="w-100">Overview</h2>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Listing Status</mat-label>
                    <mat-select [(value)]="form1.value.listingStatus" formControlName="listingStatus">
                      @for (stat of listingStatuses; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.listingStatus; track validation) {
                    <mat-error>
                      @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty ||
                      form1.get('listingStatus').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Listing Type</mat-label>
                    <mat-select [(value)]="form1.value.listingType" formControlName="listingType">
                      @for (stat of listingTypes; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.listingType; track validation) {
                    <mat-error>
                      @if (form1.get('listingType').hasError(validation.type) && (form1.get('listingType').dirty ||
                      form1.get('listingType').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Property Code</mat-label>
                    <input matInput formControlName="propertyCode" readonly="{{formReadOnly}}" required>
                    @for (validation of validationMessages.propertyCode; track validation) {
                    <mat-error>
                      @if (form1.get('propertyCode').hasError(validation.type) && (form1.get('propertyCode').dirty ||
                      form1.get('propertyCode').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Property Name</mat-label>
                    <input matInput formControlName="propertyName" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.propertyName; track validation) {
                    <mat-error>
                      @if (form1.get('propertyName').hasError(validation.type) && (form1.get('propertyName').dirty ||
                      form1.get('propertyName').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Property Type</mat-label>
                    <mat-select [(value)]="form1.value.propertyType" formControlName="propertyType">
                      @for (stat of propertyTypes; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.propertyType; track validation) {
                    <mat-error>
                      @if (form1.get('propertyType').hasError(validation.type) && (form1.get('propertyType').dirty ||
                      form1.get('propertyType').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Property Sub Type</mat-label>
                    <mat-select [(value)]="form1.value.propertySubType" formControlName="propertySubType">
                      @for (stat of propertySubTypes; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.propertySubType; track validation) {
                    <mat-error>
                      @if (form1.get('propertySubType').hasError(validation.type) && (form1.get('propertySubType').dirty
                      || form1.get('propertySubType').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Hotel Room</mat-label>
                    <mat-select [(value)]="form1.value.hotelRoomType" formControlName="hotelRoomType">
                      @for (stat of hotelRoomTypes; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.hotelRoomType; track validation) {
                    <mat-error>
                      @if (form1.get('hotelRoomType').hasError(validation.type) && (form1.get('hotelRoomType').dirty ||
                      form1.get('hotelRoomType').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Bedrooms</mat-label>
                    <input matInput formControlName="bedroomNum" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.bedroomNum; track validation) {
                    <mat-error>
                      @if (form1.get('bedroomNum').hasError(validation.type) && (form1.get('bedroomNum').dirty ||
                      form1.get('bedroomNum').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Bathrooms</mat-label>
                    <input matInput formControlName="bathroomNum" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.bathroomNum; track validation) {
                    <mat-error>
                      @if (form1.get('bathroomNum').hasError(validation.type) && (form1.get('bathroomNum').dirty ||
                      form1.get('bathroomNum').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Sleeps Max</mat-label>
                    <input matInput formControlName="sleepsMax" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sleepsMax; track validation) {
                    <mat-error>
                      @if (form1.get('sleepsMax').hasError(validation.type) && (form1.get('sleepsMax').dirty ||
                      form1.get('sleepsMax').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Sleeps Max In Beds</mat-label>
                    <input matInput formControlName="sleepsMaxInBeds" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sleepsMaxInBeds; track validation) {
                    <mat-error>
                      @if (form1.get('sleepsMaxInBeds').hasError(validation.type) && (form1.get('sleepsMaxInBeds').dirty
                      || form1.get('sleepsMaxInBeds').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label># Sofabeds</mat-label>
                    <input matInput formControlName="numSofaBeds" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.numSofaBeds; track validation) {
                    <mat-error>
                      @if (form1.get('numSofaBeds').hasError(validation.type) && (form1.get('numSofaBeds').dirty ||
                      form1.get('numSofaBeds').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>


                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label># Roll Away Beds</mat-label>
                    <input matInput formControlName="rollAwayBedNum" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.rollAwayBedNum; track validation) {
                    <mat-error>
                      @if (form1.get('rollAwayBedNum').hasError(validation.type) && (form1.get('rollAwayBedNum').dirty
                      || form1.get('rollAwayBedNum').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label># Futon Beds</mat-label>
                    <input matInput formControlName="futonBedNum" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.futonBedNum; track validation) {
                    <mat-error>
                      @if (form1.get('futonBedNum').hasError(validation.type) && (form1.get('futonBedNum').dirty ||
                      form1.get('futonBedNum').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label># Inflatable Beds</mat-label>
                    <input matInput formControlName="inflatableBedNum" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.inflatableBedNum; track validation) {
                    <mat-error>
                      @if (form1.get('inflatableBedNum').hasError(validation.type) &&
                      (form1.get('inflatableBedNum').dirty || form1.get('inflatableBedNum').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>


                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Floor Of Property (Only pplies to condos, townhomes)</mat-label>
                    <input matInput formControlName="floorOfProperty" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.floorOfProperty; track validation) {
                    <mat-error>
                      @if (form1.get('floorOfProperty').hasError(validation.type) && (form1.get('floorOfProperty').dirty
                      || form1.get('floorOfProperty').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label># of Floors In Building (if condo, townhome) or Stories in Home (if
                      House)
                    </mat-label>
                    <input matInput formControlName="floorsInBuilding" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.floorsInBuilding; track validation) {
                    <mat-error>
                      @if (form1.get('floorsInBuilding').hasError(validation.type) &&
                      (form1.get('floorsInBuilding').dirty || form1.get('floorsInBuilding').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Interior Size</mat-label>
                    <input type="number" matInput formControlName="sizeInterior" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sizeInterior; track validation) {
                    <mat-error>
                      @if (form1.get('sizeInterior').hasError(validation.type) && (form1.get('sizeInterior').dirty ||
                      form1.get('sizeInterior').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Deck/Lanai Size</mat-label>
                    <input matInput formControlName="sizeExterior" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sizeExterior; track validation) {
                    <mat-error>
                      @if (form1.get('sizeExterior').hasError(validation.type) && (form1.get('sizeExterior').dirty ||
                      form1.get('sizeExterior').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>sizeUnitOfMeasurement</mat-label>
                    <mat-select [(value)]="form1.value.sizeUnitOfMeasurement" formControlName="sizeUnitOfMeasurement">
                      @for (stat of sizeUnitOfMeasurements; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.sizeUnitOfMeasurement; track validation) {
                    <mat-error>
                      @if (form1.get('sizeUnitOfMeasurement').hasError(validation.type) &&
                      (form1.get('sizeUnitOfMeasurement').dirty || form1.get('sizeUnitOfMeasurement').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Year Build</mat-label>
                    <input matInput formControlName="yearBuilt" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.yearBuilt; track validation) {
                    <mat-error>
                      @if (form1.get('yearBuilt').hasError(validation.type) && (form1.get('yearBuilt').dirty ||
                      form1.get('yearBuilt').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Total Property Lot Size</mat-label>
                    <input matInput formControlName="sizeLot" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sizeLot; track validation) {
                    <mat-error>
                      @if (form1.get('sizeLot').hasError(validation.type) && (form1.get('sizeLot').dirty ||
                      form1.get('sizeLot').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Key Service Type</mat-label>
                    <mat-select [(value)]="form1.value.keyServiceType" formControlName="keyServiceType">
                      @for (stat of keyServiceTypes; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.keyServiceType; track validation) {
                    <mat-error>
                      @if (form1.get('keyServiceType').hasError(validation.type) && (form1.get('keyServiceType').dirty
                      || form1.get('keyServiceType').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>New Reservation Alert Email</mat-label>
                    <input matInput formControlName="newReservationAlertEmail" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.newReservationAlertEmail; track validation) {
                    <mat-error>
                      @if (form1.get('newReservationAlertEmail').hasError(validation.type) &&
                      (form1.get('newReservationAlertEmail').dirty || form1.get('newReservationAlertEmail').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                @if (form1?.get?.('listingType')?.value == 2 && !loadState.compositeListingList) {
                <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                  (click)="loadComponent('compositeListingList')">Load Composite Listing List</button>
                }
                @if (form1?.get?.('listingType')?.value == 2 && loadState.compositeListingList) {
                <app-composite-listing-list [shortTermRentalId]="shortTermRentalId" [parentListingType]="form1?.get?.('listingType')?.value"></app-composite-listing-list>
                }

                <!-- Hotel Room V2 (post 2026-04-28 split): hotel-room children come from str_hotel_listing
                     via the dedicated hotel-listing component. Reuses the same compositeListingList lazy-load
                     toggle so the existing "Children" tab UX behaves identically across both listing types. -->
                @if (form1?.get?.('listingType')?.value == 3 && !loadState.compositeListingList) {
                <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                  (click)="loadComponent('compositeListingList')">Load Hotel Room Children</button>
                }
                @if (form1?.get?.('listingType')?.value == 3 && loadState.compositeListingList) {
                <app-hotel-listing-list [shortTermRentalId]="shortTermRentalId"></app-hotel-listing-list>
                }
                <!-- <div class="col-md-6 col-lg-3">
                <mat-form-field class="w-100">
                  <mat-label>Property Rank</mat-label>
                  <mat-select [(value)]="form1.value.propertyRank" formControlName="propertyRank">
                    <mat-option *ngFor="let stat of propertyRanks" [value]="stat.value">
                      {{stat.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngFor="let validation of validationMessages.propertyRank">
                    <mat-error class="error-message"
                      *ngIf="form1.get('propertyRank').hasError(validation.type) && (form1.get('propertyRank').dirty || form1.get('propertyRank').touched)">
                    {{validation.message}}</mat-error>
                  </mat-error>
                </mat-form-field>
              </div> -->

              </div>
            </div>


            <div id="section-settings-financials" class="settings-subsection">

              <h3 class="settings-subsection-title">Financials</h3>
              <div class="row m-0 mt-4 align-items-end">
                <div class="col-lg-12">
                  <h2 class="w-100">Financials</h2>
                </div>
                <!-- 10-23-2024 Divy : Commenting below fields as we are not syncing these fields to YM -->
                <!-- <div class="col-md-6 col-lg-3">
              <div formGroupName="rateBucket">
                <mat-form-field class="w-100">
                  <mat-label>Rate Bucket</mat-label>
                  <mat-select [(value)]="form1.value.rateBucketId" formControlName="rateBucketId">
                    <mat-option *ngFor="let stat of rateBuckets" [value]="stat.rateBucketId">
                      {{stat.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngFor="let validation of validationMessages.rateBucketId">
                    <mat-error class="error-message"
                      *ngIf="form1.get('rateBucketId').hasError(validation.type) && (form1.get('rateBucketId').dirty || form1.get('rateBucketId').touched)">
                    {{validation.message}}</mat-error>
                  </mat-error>
                </mat-form-field>
              </div>
            </div> -->
                <div class="col-md-6 col-lg-3">
                  <div class="w-100">
                    <mat-label>Management Commission: <b>{{mgmtCommission.value*100}}%</b></mat-label>
                    <div>
                      <mat-slider class="flex-1" min="0" max="1" step=".005" pTooltip="Range: 0 to 100 as percent. "
                        tooltipPosition="bottom">
                        <input matSliderThumb #mgmtCommission formControlName="mgmtCommission">
                      </mat-slider>
                      @for (validation of validationMessages.mgmtCommission; track validation) {
                      <mat-error>
                        @if (form1.get('mgmtCommission').hasError(validation.type) && (form1.get('mgmtCommission').dirty
                        || form1.get('mgmtCommission').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </div>
                  </div>
                </div>
                <!-- 09-27-2024 Divy : Commented below four fields as we are no more using it in Wiki
            This will be updated in YM now on -->
                <!-- <div class="col-md-6 col-lg-3">
            <div class="w-100">
              <mat-label>Rate Bucket Adjustment: <b>{{rateBucketAdjusterPct.value*100}}%</b>
            </mat-label>
            <div>
              <mat-slider class="flex-1" #rateBucketAdjusterPct formControlName="rateBucketAdjusterPct" min="-1" max="1"
                step=".01" pTooltip="Range: -100 to 100 as percent. " tooltipPosition="bottom">
              </mat-slider>
            </div>
          </div>
        </div> -->
                <div class="col-md-6 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Priced from (as shown on website in green)</mat-label>
                    <input matInput formControlName="minNightlyRate" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.minNightlyRate; track validation) {
                    <mat-error>
                      @if (form1.get('minNightlyRate').hasError(validation.type) && (form1.get('minNightlyRate').dirty
                      || form1.get('minNightlyRate').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <!-- <div class="col-md-6 col-lg-3">
        <mat-form-field class="w-100">
          <mat-label>Minimum Length of Stay</mat-label>
          <input matInput formControlName="minLengthOfStay" readonly="{{formReadOnly}}">
          <mat-error *ngFor="let validation of validationMessages.minLengthOfStay">
            <mat-error class="error-message"
              *ngIf="form1.get('minLengthOfStay').hasError(validation.type) && (form1.get('minLengthOfStay').dirty || form1.get('minLengthOfStay').touched)">
              {{validation.message}}
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div> -->
                <!-- <div class="col-md-6 col-lg-3">
      <mat-form-field class="w-100">
        <mat-label>Annual Revenue Target</mat-label>
        <input matInput formControlName="annualRevTargetAmnt" readonly="{{formReadOnly}}">
        <mat-error *ngFor="let validation of validationMessages.annualRevTargetAmnt">
          <mat-error class="error-message"
            *ngIf="form1.get('annualRevTargetAmnt').hasError(validation.type) && (form1.get('annualRevTargetAmnt').dirty || form1.get('annualRevTargetAmnt').touched)">
            {{validation.message}}
          </mat-error>
        </mat-error>
      </mat-form-field>
    </div> -->




                <!-- 10-23-2024 Divy : Commenting below fields as we are not syncing these fields to YM -->
                <!-- <div class="col-md-6 col-lg-3">
    <mat-form-field class="w-100">
      <mat-label>Guest Fee (Nightly)</mat-label>
      <input matInput formControlName="guestFeeNightly" readonly="{{formReadOnly}}">
      <mat-error *ngFor="let validation of validationMessages.guestFeeNightly">
        <mat-error class="error-message"
          *ngIf="form1.get('guestFeeNightly').hasError(validation.type) && (form1.get('guestFeeNightly').dirty || form1.get('guestFeeNightly').touched)">
          {{validation.message}}
        </mat-error>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-md-6 col-lg-3">
    <mat-form-field class="w-100">
      <mat-label>Cleaning Fee Interim</mat-label>
      <input matInput formControlName="cleaningFeeInterim" readonly="{{formReadOnly}}">
      <mat-error *ngFor="let validation of validationMessages.cleaningFeeInterim">
        <mat-error class="error-message"
          *ngIf="form1.get('cleaningFeeInterim').hasError(validation.type) && (form1.get('cleaningFeeInterim').dirty || form1.get('cleaningFeeInterim').touched)">
          {{validation.message}}
        </mat-error>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-md-6 col-lg-3">
    <mat-form-field class="w-100">
      <mat-label>Cleaning Fee Departure</mat-label>
      <input matInput formControlName="cleaningFeeDeparture" readonly="{{formReadOnly}}">
      <mat-error *ngFor="let validation of validationMessages.cleaningFeeDeparture">
        <mat-error class="error-message"
          *ngIf="form1.get('cleaningFeeDeparture').hasError(validation.type) && (form1.get('cleaningFeeDeparture').dirty || form1.get('cleaningFeeDeparture').touched)">
          {{validation.message}}
        </mat-error>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-md-6 col-lg-3">
    <mat-form-field class="w-100">
      <mat-label>Sales/GET Tax Rate</mat-label>
      <input matInput formControlName="salesTaxRate" readonly="{{formReadOnly}}">
      <mat-error *ngFor="let validation of validationMessages.salesTaxRate">
        <mat-error class="error-message"
          *ngIf="form1.get('salesTaxRate').hasError(validation.type) && (form1.get('salesTaxRate').dirty || form1.get('salesTaxRate').touched)">
          {{validation.message}}
        </mat-error>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-md-6 col-lg-3">
    <mat-form-field class="w-100">
      <mat-label>Room/TAT Tax Rate</mat-label>
      <input matInput formControlName="roomTaxRate" readonly="{{formReadOnly}}">
      <mat-error *ngFor="let validation of validationMessages.roomTaxRate">
        <mat-error class="error-message"
          *ngIf="form1.get('roomTaxRate').hasError(validation.type) && (form1.get('roomTaxRate').dirty || form1.get('roomTaxRate').touched)">
          {{validation.message}}
        </mat-error>
      </mat-error>
    </mat-form-field>
  </div> -->
              </div>
            </div>


            <div id="section-settings-address" class="settings-subsection">

              <h3 class="settings-subsection-title">Address</h3>
              <div class="row wrap m-0 align-items-start mt-4 gy-4">
                <div class="row wrap m-0 col-lg-6">
                  <div class="col-lg-12">
                    <h2 style="flex: 0 0 100%">Address</h2>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Street #</mat-label>
                      <input matInput formControlName="adrStreetNumber" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrStreetNumber; track validation) {
                      <mat-error>
                        @if (form1.get('adrStreetNumber').hasError(validation.type) &&
                        (form1.get('adrStreetNumber').dirty || form1.get('adrStreetNumber').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Street Name</mat-label>
                      <input matInput formControlName="adrStreetName" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrStreetName; track validation) {
                      <mat-error>
                        @if (form1.get('adrStreetName').hasError(validation.type) && (form1.get('adrStreetName').dirty
                        || form1.get('adrStreetName').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Unit #</mat-label>
                      <input matInput formControlName="adrUnit" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrUnit; track validation) {
                      <mat-error>
                        @if (form1.get('adrUnit').hasError(validation.type) && (form1.get('adrUnit').dirty ||
                        form1.get('adrUnit').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Address 2</mat-label>
                      <input matInput formControlName="adr2" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adr2; track validation) {
                      <mat-error>
                        @if (form1.get('adr2').hasError(validation.type) && (form1.get('adr2').dirty ||
                        form1.get('adr2').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>City</mat-label> <input matInput formControlName="adrCity" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrCity; track validation) {
                      <mat-error>
                        @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty ||
                        form1.get('adrCity').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>State</mat-label> <input matInput formControlName="adrState"
                        readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrState; track validation) {
                      <mat-error>
                        @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty ||
                        form1.get('adrState').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Postal Code</mat-label> <input matInput formControlName="adrPostalCode"
                        readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrPostalCode; track validation) {
                      <mat-error>
                        @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty
                        || form1.get('adrPostalCode').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>County</mat-label>
                      <input matInput formControlName="adrCounty" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrCounty; track validation) {
                      <mat-error>
                        @if (form1.get('adrCounty').hasError(validation.type) && (form1.get('adrCounty').dirty ||
                        form1.get('adrCounty').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="w-100">
                      <mat-label>Country</mat-label>
                      <mat-select [(value)]="form1.value.adrCountry" formControlName="adrCountry">
                        @for (stat of countries; track stat) {
                        <mat-option [value]="stat.value">
                          {{stat.name}}
                        </mat-option>
                        }
                      </mat-select>
                      @for (validation of validationMessages.adrCountry; track validation) {
                      <mat-error>
                        @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty ||
                        form1.get('adrCountry').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="row wrap m-0 col-lg-6">
                  <div class="col-lg-12">
                    <h3 class="w-100">Location</h3>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div formGroupName="development">
                      <mat-form-field class="w-100">
                        <mat-label>Development</mat-label>
                        <mat-select [(value)]="form1.value.developmentId" formControlName="developmentId">
                          @for (stat of developments; track stat) {
                          <mat-option [value]="stat.developmentId">
                            {{stat.addressDevelopmentName}}
                          </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.developmentId; track validation) {
                        <mat-error>
                          @if (form1.get('development.developmentId').hasError(validation.type) &&
                          (form1.get('development.developmentId').dirty ||
                          form1.get('development.developmentId').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Building</mat-label>
                      <input matInput formControlName="adrBuildingName" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrBuildingName; track validation) {
                      <mat-error>
                        @if (form1.get('adrBuildingName').hasError(validation.type) &&
                        (form1.get('adrBuildingName').dirty || form1.get('adrBuildingName').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Complex</mat-label>
                      <input matInput formControlName="adrComplexName" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrComplexName; track validation) {
                      <mat-error>
                        @if (form1.get('adrComplexName').hasError(validation.type) && (form1.get('adrComplexName').dirty
                        || form1.get('adrComplexName').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>District</mat-label>
                      <input matInput formControlName="adrDistrictName" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrDistrictName; track validation) {
                      <mat-error>
                        @if (form1.get('adrDistrictName').hasError(validation.type) &&
                        (form1.get('adrDistrictName').dirty || form1.get('adrDistrictName').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Metro</mat-label>
                      <input matInput formControlName="adrMetro" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrMetro; track validation) {
                      <mat-error>
                        @if (form1.get('adrMetro').hasError(validation.type) && (form1.get('adrMetro').dirty ||
                        form1.get('adrMetro').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Region</mat-label>
                      <input matInput formControlName="adrRegion" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrRegion; track validation) {
                      <mat-error>
                        @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty ||
                        form1.get('adrRegion').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Island</mat-label>
                      <input matInput formControlName="adrIsland" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrIsland; track validation) {
                      <mat-error>
                        @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty ||
                        form1.get('adrIsland').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Market Location</mat-label>
                      <mat-select [(value)]="form1.value.locationId" formControlName="locationId">
                        @for (stat of locations; track stat) {
                        <mat-option [value]="stat.locationId">
                          {{stat.name}}
                        </mat-option>
                        }
                      </mat-select>
                      @for (validation of validationMessages.locationId; track validation) {
                      <mat-error>
                        @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty ||
                        form1.get('locationId').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div class="col-md-6 col-lg-6 banner-form-dropdown banner-autoComplete p-float-label">
                    <p-autoComplete #locationSearch class="error-bg" appendTo="body" placeholder=""
                      formControlName="rULocationId" [suggestions]="filteredNames"
                      (completeMethod)="changeNameFilter($event.query)" field="name" [minLength]="1"
                      forceSelection=true>

                      <ng-template let-filteredNames pTemplate="item">
                        <div class="country-item">
                          <div class="title" style="color: orange;">
                            {{filteredNames.name}}</div>
                        </div>
                      </ng-template>
                    </p-autoComplete>
                    <label for="Search location" style="left: 20px; margin-top: -5px;">LocationId</label>
                  </div>
                  <!-- <div class="col-md-6 col-lg-6">
      <mat-form-field class="w-100">
        <mat-label>Select location</mat-label>
        <mat-select [(value)]="form1.value.rULocationId" formControlName="rULocationId">
          <mat-option *ngFor="let locationDetail of locationDetails" [value]="locationDetail.locationId">
            {{locationDetail.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngFor="let validation of validationMessages.rULocationId">
          <mat-error class="error-message"
            *ngIf="form1.get('rULocationId').hasError(validation.type) && (form1.get('rULocationId').dirty || form1.get('rULocationId').touched)">
          {{validation.message}}</mat-error>
        </mat-error>
      </mat-form-field>
    </div> -->
                </div>
                <div class="row wrap m-0 col-md-6">
                  <div class="col-lg-12">
                    <h3 class="w-100">Reference</h3>
                  </div>

                  <div class="col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Cross Street</mat-label>
                      <input matInput formControlName="adrCrossStreet" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrCrossStreet; track validation) {
                      <mat-error>
                        @if (form1.get('adrCrossStreet').hasError(validation.type) && (form1.get('adrCrossStreet').dirty
                        || form1.get('adrCrossStreet').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Longitude</mat-label>
                      <input matInput formControlName="adrLongitude" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrLongitude; track validation) {
                      <mat-error>
                        @if (form1.get('adrLongitude').hasError(validation.type) && (form1.get('adrLongitude').dirty ||
                        form1.get('adrLongitude').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field class="w-100">
                      <mat-label>Latitude</mat-label>
                      <input matInput formControlName="adrLatitude" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.adrLatitude; track validation) {
                      <mat-error>
                        @if (form1.get('adrLatitude').hasError(validation.type) && (form1.get('adrLatitude').dirty ||
                        form1.get('adrLatitude').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field class="w-100" formGroupName="featureDesc">
                      <mat-label>Property Phone Number</mat-label>
                      <input matInput formControlName="propertyPhoneNumber" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.propertyPhoneNumber; track validation) {
                      <mat-error>
                        @if (form1.get('propertyPhoneNumber').hasError(validation.type) &&
                        (form1.get('propertyPhoneNumber').dirty || form1.get('propertyPhoneNumber').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field class="w-100" formGroupName="featureDesc">
                      <mat-label>Property Fax Number</mat-label>
                      <input matInput formControlName="propertyFaxNumber" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.propertyFaxNumber; track validation) {
                      <mat-error>
                        @if (form1.get('propertyFaxNumber').hasError(validation.type) &&
                        (form1.get('propertyFaxNumber').dirty || form1.get('propertyFaxNumber').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>


            <div id="section-settings-channels" class="settings-subsection">

              <h3 class="settings-subsection-title">Channels</h3>
              <div class="row wrap m-0 mt-4">
                <div class="col-lg-12">
                  <h2 class="w-100">Marketing</h2>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Show Public Calendar</mat-label>
                    <mat-select [(value)]="form1.value.showPublicCalendar" formControlName="showPublicCalendar">
                      @for (stat of booleans; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.showPublicCalendar; track validation) {
                    <mat-error>
                      @if (form1.get('showPublicCalendar').hasError(validation.type) &&
                      (form1.get('showPublicCalendar').dirty || form1.get('showPublicCalendar').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Enable Book Online</mat-label>
                    <mat-select [(value)]="form1.value.showBookOnline" formControlName="showBookOnline">
                      @for (stat of booleans; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.showBookOnline; track validation) {
                    <mat-error>
                      @if (form1.get('showBookOnline').hasError(validation.type) && (form1.get('showBookOnline').dirty
                      || form1.get('showBookOnline').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3" style="padding-top: 12px;">
                  <mat-slide-toggle formControlName="flexiblePolicyToggle">
                    Flexible Policy Eligible
                  </mat-slide-toggle>
                  <mat-icon
                    style="font-size:18px;vertical-align:middle;margin-left:6px;color:#666;cursor:help;"
                    matTooltip="When ON: this property may qualify for Flexible policy (last-minute, low-occupancy cancellations). When OFF: all cancellations always use Standard Strict tiers (>90d full, 45-90d half, <45d no refund). Use KBMAdmin → Guests → Cancellation Policy to evaluate any reservation."
                    matTooltipShowDelay="200">info_outline</mat-icon>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Accomodation Tax Id</mat-label>
                    <input matInput formControlName="taxId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.taxId; track validation) {
                    <mat-error>
                      @if (form1.get('taxId').hasError(validation.type) && (form1.get('taxId').dirty ||
                      form1.get('taxId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>GE Tax Id</mat-label>
                    <input matInput formControlName="geTaxId" readonly="{{formReadOnly}}">
                  </mat-form-field>
                </div>
                <div class="col-md-2">
                  <mat-form-field class="w-100">
                    <mat-label>Permit #</mat-label>
                    <input matInput formControlName="permitId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.permitId; track validation) {
                    <mat-error>
                      @if (form1.get('permitId').hasError(validation.type) && (form1.get('permitId').dirty ||
                      form1.get('permitId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-1">
                  <mat-form-field class="w-100">
                    <mat-label>Parcel Id</mat-label>
                    <input matInput formControlName="parcelId">
                    @for (validation of validationMessages.parcelId; track validation) {
                    <mat-error>
                      @if (form1.get('parcelId').hasError(validation.type) && (form1.get('parcelId').dirty ||
                      form1.get('parcelId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Rental United #</mat-label>
                    <input matInput formControlName="ruPropertyId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.ruPropertyId; track validation) {
                    <mat-error>
                      @if (form1.get('ruPropertyId').hasError(validation.type) && (form1.get('ruPropertyId').dirty ||
                      form1.get('ruPropertyId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Matterport Id</mat-label>
                    <input matInput formControlName="matterportId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.matterportId; track validation) {
                    <mat-error>
                      @if (form1.get('matterportId').hasError(validation.type) && (form1.get('matterportId').dirty ||
                      form1.get('matterportId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Locale</mat-label>
                    <mat-select [(value)]="form1.value.locale" formControlName="locale">
                      @for (stat of locales; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.locale; track validation) {
                    <mat-error>
                      @if (form1.get('locale').hasError(validation.type) && (form1.get('locale').dirty ||
                      form1.get('locale').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>SL PropertyId</mat-label>
                    <input type="number" matInput formControlName="slPropertyId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.slPropertyId; track validation) {
                    <mat-error>
                      @if (form1.get('slPropertyId').hasError(validation.type) && (form1.get('slPropertyId').dirty ||
                      form1.get('slPropertyId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>VRBO Listing #</mat-label>
                    <input matInput formControlName="vrboId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.vrboId; track validation) {
                    <mat-error>
                      @if (form1.get('vrboId').hasError(validation.type) && (form1.get('vrboId').dirty ||
                      form1.get('vrboId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>VRBO Str Id</mat-label>
                    <input matInput formControlName="vrboShortTermRentalId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.vrboShortTermRentalId; track validation) {
                    <mat-error>
                      @if (form1.get('vrboShortTermRentalId').hasError(validation.type) &&
                      (form1.get('vrboShortTermRentalId').dirty || form1.get('vrboShortTermRentalId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>VRBO Display Id</mat-label>
                    <input matInput formControlName="vrboDisplayId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.vrboDisplayId; track validation) {
                    <mat-error>
                      @if (form1.get('vrboDisplayId').hasError(validation.type) && (form1.get('vrboDisplayId').dirty ||
                      form1.get('vrboDisplayId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Booking Com Id</mat-label>
                    <input matInput formControlName="bookingComId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.bookingComId; track validation) {
                    <mat-error>
                      @if (form1.get('bookingComId').hasError(validation.type) && (form1.get('bookingComId').dirty ||
                      form1.get('bookingComId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Airbnb #</mat-label>
                    <input matInput formControlName="airbnbId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.airbnbId; track validation) {
                    <mat-error>
                      @if (form1.get('airbnbId').hasError(validation.type) && (form1.get('airbnbId').dirty ||
                      form1.get('airbnbId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Expedia #</mat-label>
                    <input matInput formControlName="expediaId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.expediaId; track validation) {
                    <mat-error>
                      @if (form1.get('expediaId').hasError(validation.type) && (form1.get('expediaId').dirty ||
                      form1.get('expediaId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Marriott #</mat-label>
                    <input matInput formControlName="marriottId" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.marriottId; track validation) {
                    <mat-error>
                      @if (form1.get('marriottId').hasError(validation.type) && (form1.get('marriottId').dirty ||
                      form1.get('marriottId').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                @if (true && !loadState.ruPropertiesStatus) {
                <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                  (click)="loadComponent('ruPropertiesStatus')">Load RU Properties Status</button>
                }
                @if (loadState.ruPropertiesStatus) {
                <app-ru-properties-status-list [shortTermRentalId]="shortTermRentalId" [shortTermRental]="property"
                  [showFilter]="false" [showPagination]="false"></app-ru-properties-status-list>
                }
              </div>
            </div>


            <div id="section-settings-operations" class="settings-subsection">

              <h3 class="settings-subsection-title">Operations</h3>
              <div formGroupName="instruction" class="row wrap m-0 mt-4">
                <br>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Property Notes (Internal)</mat-label>
                    <textarea matInput formControlName="opsNotes" readonly="{{formReadOnly}}" matTextareaAutosize
                      matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter opsNotes, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.opsNotes; track validation) {
                    <mat-error>
                      @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty ||
                      form1.get('opsNotes').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-12">
                  <h2 style="flex: 0 0 100%">Access Codes (default)</h2>
                </div>
                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>Front Door</mat-label>
                    <input matInput formControlName="codeFrontDoor" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codeFrontDoor; track validation) {
                    <mat-error>
                      @if (form1.get('codeFrontDoor').hasError(validation.type) && (form1.get('codeFrontDoor').dirty ||
                      form1.get('codeFrontDoor').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>Garage Code</mat-label>
                    <input matInput formControlName="codeGarage" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codeGarage; track validation) {
                    <mat-error>
                      @if (form1.get('codeGarage').hasError(validation.type) && (form1.get('codeGarage').dirty ||
                      form1.get('codeGarage').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>HOA Gate Code</mat-label>
                    <input matInput formControlName="codeHoaGate" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codeHoaGate; track validation) {
                    <mat-error>
                      @if (form1.get('codeHoaGate').hasError(validation.type) && (form1.get('codeHoaGate').dirty ||
                      form1.get('codeHoaGate').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>Pool Code</mat-label>
                    <input matInput formControlName="codePool" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codePool; track validation) {
                    <mat-error>
                      @if (form1.get('codePool').hasError(validation.type) && (form1.get('codePool').dirty ||
                      form1.get('codePool').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>Recreation Room Code</mat-label>
                    <input matInput formControlName="codeRecreation" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codeRecreation; track validation) {
                    <mat-error>
                      @if (form1.get('codeRecreation').hasError(validation.type) && (form1.get('codeRecreation').dirty
                      || form1.get('codeRecreation').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-12 col-lg-2">
                  <mat-form-field class="w-100">
                    <mat-label>Code Gate</mat-label>
                    <input matInput formControlName="codeGate" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.codeGate; track validation) {
                    <mat-error>
                      @if (form1.get('codeGate').hasError(validation.type) && (form1.get('codeGate').dirty ||
                      form1.get('codeGate').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-md-12 col-lg-12">
                  <h2 class="w-100">WIFI Access Code
                    <a style="color: dodgerblue;" href="javascript:void(0)" (click)="onOpenQRCodeComponent()"
                      class="ms-3">View QR Code</a>
                  </h2>
                </div>
                <div class="col-md-12 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>WIFI Name (SSID)</mat-label>
                    <input matInput formControlName="wifiName" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.wifiName; track validation) {
                    <mat-error>
                      @if (form1.get('wifiName').hasError(validation.type) && (form1.get('wifiName').dirty ||
                      form1.get('wifiName').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>WIFI Name 5G</mat-label>
                    <input matInput formControlName="wifiName5g" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.wifiName5g; track validation) {
                    <mat-error>
                      @if (form1.get('wifiName5g').hasError(validation.type) && (form1.get('wifiName5g').dirty ||
                      form1.get('wifiName5g').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>WIFI Password</mat-label>
                    <input matInput formControlName="wifiPassword" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.wifiPassword; track validation) {
                    <mat-error>
                      @if (form1.get('wifiPassword').hasError(validation.type) && (form1.get('wifiPassword').dirty ||
                      form1.get('wifiPassword').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>Wifi Securities</mat-label>
                    <mat-select [(value)]="form1.value.wifiSecurity" formControlName="wifiSecurity">
                      @for (stat of wifiSecurities; track stat) {
                      <mat-option [value]="stat.value">
                        {{stat.name}}
                      </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.wifiSecurity; track validation) {
                    <mat-error>
                      @if (form1.get('wifiSecurity').hasError(validation.type) && (form1.get('wifiSecurity').dirty ||
                      form1.get('wifiSecurity').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>

                  <!-- <span class="p-float-label w-100 mb-4">
          <p-dropdown class="w-100" [options]="wifiSecurities" formControlName="wifiSecurity"
            appendTo="body" optionLabel="name" optionValue="value"
          placeholder="Wifi Securities"></p-dropdown>
          <span *ngFor="let validation of validationMessages.wifiSecurity">
            <small class="p-invalid"
              *ngIf="form1.get('wifiSecurity').hasError(validation.type) && (form1.get('wifiSecurity').dirty || form1.get('wifiSecurity').touched)">{{validation.message}}
            </small>
          </span>
        </span> -->
                </div>
                <div class="col-md-12 col-lg-12">
                  <h2 class="w-100">Directions To Property</h2>
                </div>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Directions To Property: Link</mat-label>
                    <input matInput formControlName="directionsLinkToProperty" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.directionsLinkToProperty; track validation) {
                    <mat-error>
                      @if (form1.get('directionsLinkToProperty').hasError(validation.type) &&
                      (form1.get('directionsLinkToProperty').dirty || form1.get('directionsLinkToProperty').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Directions To Property: Description</mat-label>
                    <textarea matInput formControlName="directionsToProperty" readonly="{{formReadOnly}}"
                      matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter directionsToProperty, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.directionsToProperty; track validation) {
                    <mat-error>
                      @if (form1.get('directionsToProperty').hasError(validation.type) &&
                      (form1.get('directionsToProperty').dirty || form1.get('directionsToProperty').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-12">
                  <h2 class="w-100">Arrival Instructions</h2>
                </div>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Arrival Instructions: General</mat-label>
                    <textarea matInput formControlName="arrivalInstructions" readonly="{{formReadOnly}}"
                      matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter arrivalInstructions, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.arrivalInstructions; track validation) {
                    <mat-error>
                      @if (form1.get('arrivalInstructions').hasError(validation.type) &&
                      (form1.get('arrivalInstructions').dirty || form1.get('arrivalInstructions').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Arrival Instructions: No Greeter - Self Service</mat-label>
                    <textarea matInput formControlName="keyServiceSelfServeDesc" readonly="{{formReadOnly}}"
                      matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter keyServiceSelfServeDesc, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.keyServiceSelfServeDesc; track validation) {
                    <mat-error>
                      @if (form1.get('keyServiceSelfServeDesc').hasError(validation.type) &&
                      (form1.get('keyServiceSelfServeDesc').dirty || form1.get('keyServiceSelfServeDesc').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-lg-12">
                  <mat-form-field class="w-100">
                    <mat-label>Arrival Instructions: Front Desk / Greeter</mat-label>
                    <textarea matInput formControlName="keyServiceAssistedDesc" readonly="{{formReadOnly}}"
                      matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter keyServiceAssistedDesc, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.keyServiceAssistedDesc; track validation) {
                    <mat-error>
                      @if (form1.get('keyServiceAssistedDesc').hasError(validation.type) &&
                      (form1.get('keyServiceAssistedDesc').dirty || form1.get('keyServiceAssistedDesc').touched)) {
                      <mat-error class="error-message">
                        {{validation.message}}
                      </mat-error>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>


              <div id="section-settings-maintenance-event" class="settings-subsection">

                <h3 class="settings-subsection-title">Maintenance Event</h3>
                @if (true && !loadState.maintenanceEvents) {
                <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                  (click)="loadComponent('maintenanceEvents')">Load Maintenance Events</button>
                }
                @if (loadState.maintenanceEvents) {
                <app-maintenance-event-list [shortTermRentalId]="shortTermRentalId"></app-maintenance-event-list>
                }
              </div>


              <div id="section-settings-property-condition" class="settings-subsection">

                <h3 class="settings-subsection-title">Property Condition</h3>
                @if (true && !loadState.propertyCondition) {
                <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                  (click)="loadComponent('propertyCondition')">Load Property Condition</button>
                }
                @if (loadState.propertyCondition) {
                <app-property-condition-list [shortTermRentalId]="shortTermRentalId"></app-property-condition-list>
                }
              </div>
            </div>
            <div id="section-settings-compendium" class="settings-subsection">

              <h3 class="settings-subsection-title">Compendium</h3>
              @if (true && !loadState.compendiumsJoin) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('compendiumsJoin')">Load
                Compendiums</button>
              }
              @if (loadState.compendiumsJoin) {
              <app-compendiums-short-term-rental-join-list
                [shortTermRentalId]="shortTermRentalId"></app-compendiums-short-term-rental-join-list>
              }
            </div>
          </section>

          <section id="section-marketing" class="jump-section">
            <h2 class="section-header">Marketing</h2>

            <div class="subsection" id="section-marketing-desc">
              <h3 class="subsection-title">Descriptions</h3>
              <br>
              <div class="container-fluid">
                <div formGroupName="featureDesc" class="row m-0">
                  <div class="col-sm-12 col-lg-12">
                    <h2>Lead Features</h2>
                  </div>
                  <div class="col-sm-12 col-lg-12">
                    <p>Lead Features are highlighted in the marketing materials and the first text the
                      guest reads.
                      First activate the lead feature. Next, click the row and add the Lead Feature
                      text in the 'descriptive words' field and press Update.</p>
                  </div>
                  <div class="col-sm-12 col-lg-12 mb-5">
                    @if (featureListsLoaded) {
                    <app-feature-list style="flex: 0 0 calc(100%-10px)" [featuresList]="featuresList" title=""
                      [shortTermRentalId]="shortTermRentalId" featureType="leadFeature" describesType="">
                    </app-feature-list>
                    }
                  </div>
                  <div class="col-sm-12 col-lg-12 mb-5">
                    <button style="float:right;" mat-raised-button color="primary"
                      (click)="getDynamicLongPropHeadline()">Generate Dynamic Long Property
                      Headline</button>
                  </div>
                  @if (property?.listingType != undefined && (property?.listingType == 2 || property?.listingType == 3)) {
                  <div class="col-sm-12 col-lg-12 mb-5">
                    <button style="float:right;" mat-raised-button color="primary"
                      (click)="getDynamicLongPropDescription()">Generate Dynamic Long Property
                      Description</button>
                  </div>
                  }
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Listing Name
                        <mat-hint>(<code>{{listingNameLength}}</code> of <code>20</code> characters)
                        </mat-hint>
                      </mat-label>

                      <input matInput formControlName="listingName" readonly="{{formReadOnly}}" maxlength="20">
                      @for (validation of validationMessages.listingName; track validation) {
                      <mat-error>
                        @if (form1.get('listingName').hasError(validation.type) && (form1.get('listingName').dirty ||
                        form1.get('listingName').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Short Property Description (WEBSITE LONG HEADLINE)<mat-hint>
                          (<code>{{propDescShortLength}}</code> of
                          <code>250</code> characters)
                        </mat-hint>
                      </mat-label>
                      <input matInput formControlName="propDescShort" readonly="{{formReadOnly}}" maxlength="250">

                      @for (validation of validationMessages.propDescShort; track validation) {
                      <mat-error>
                        @if (form1.get('propDescShort').hasError(validation.type) && (form1.get('propDescShort').dirty
                        || form1.get('propDescShort').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Channel Headline - Default (OTA SHORT HEADLINE) <mat-hint>
                          (<code>{{headlineChannelDefaultFieldLength}}</code> of <code>50</code>
                          characters)
                        </mat-hint>
                      </mat-label>
                      <input matInput formControlName="headlineChannelDefault" readonly="{{formReadOnly}}"
                        maxlength="50">

                      @for (validation of validationMessages.headlineChannelDefault; track validation) {
                      <mat-error>
                        @if (form1.get('headlineChannelDefault').hasError(validation.type) &&
                        (form1.get('headlineChannelDefault').dirty || form1.get('headlineChannelDefault').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Channel Headline - Special Offer (OTA LONG HEADLINE) <mat-hint>
                          (<code>{{headlineChannelSpecialOfferLength}}</code> of <code>150</code>
                          characters)
                        </mat-hint>
                      </mat-label>
                      <input matInput formControlName="headlineChannelSpecialOffer" readonly="{{formReadOnly}}"
                        maxlength="150">

                      @for (validation of validationMessages.headlineChannelSpecialOffer; track validation) {
                      <mat-error>
                        @if (form1.get('headlineChannelSpecialOffer').hasError(validation.type) &&
                        (form1.get('headlineChannelSpecialOffer').dirty ||
                        form1.get('headlineChannelSpecialOffer').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>VRBO Headline Description</mat-label>
                      <textarea matInput formControlName="vrboHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter vrboHeadline, paragraphs ok."></textarea>
                      @for (validation of validationMessages.vrboHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('vrboHeadline').hasError(validation.type) && (form1.get('vrboHeadline').dirty ||
                        form1.get('vrboHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Airbnb Headline</mat-label>
                      <textarea matInput formControlName="airbnbHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter Airbnb-specific headline."></textarea>
                      @for (validation of validationMessages.airbnbHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('airbnbHeadline').hasError(validation.type) && (form1.get('airbnbHeadline').dirty ||
                        form1.get('airbnbHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Booking.com Headline</mat-label>
                      <textarea matInput formControlName="bookingComHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter Booking.com-specific headline."></textarea>
                      @for (validation of validationMessages.bookingComHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('bookingComHeadline').hasError(validation.type) && (form1.get('bookingComHeadline').dirty ||
                        form1.get('bookingComHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Expedia Headline</mat-label>
                      <textarea matInput formControlName="expediaHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter Expedia-specific headline."></textarea>
                      @for (validation of validationMessages.expediaHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('expediaHeadline').hasError(validation.type) && (form1.get('expediaHeadline').dirty ||
                        form1.get('expediaHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Google Headline</mat-label>
                      <textarea matInput formControlName="googleHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter Google-specific headline."></textarea>
                      @for (validation of validationMessages.googleHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('googleHeadline').hasError(validation.type) && (form1.get('googleHeadline').dirty ||
                        form1.get('googleHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Marriott Headline</mat-label>
                      <textarea matInput formControlName="marriottHeadline" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter Marriott-specific headline."></textarea>
                      @for (validation of validationMessages.marriottHeadline; track validation) {
                      <mat-error>
                        @if (form1.get('marriottHeadline').hasError(validation.type) && (form1.get('marriottHeadline').dirty ||
                        form1.get('marriottHeadline').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Headline Key Words</mat-label>
                      <input matInput formControlName="headlineKeyWords" maxlength="25" readonly="{{formReadOnly}}">
                      @for (validation of validationMessages.headlineKeyWords; track validation) {
                      <mat-error>
                        @if (form1.get('headlineKeyWords').hasError(validation.type) &&
                        (form1.get('headlineKeyWords').dirty || form1.get('headlineKeyWords').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Website Key Words (SEO)</mat-label>
                      <textarea matInput formControlName="propDescShortKeyWords" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.propDescShortKeyWords; track validation) {
                      <mat-error>
                        @if (form1.get('propDescShortKeyWords').hasError(validation.type) &&
                        (form1.get('propDescShortKeyWords').dirty || form1.get('propDescShortKeyWords').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Special Offers (Website)</mat-label>
                      <textarea matInput formControlName="specialOfferDesc" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter specialOfferDesc, no paragraphs."></textarea>
                      @for (validation of validationMessages.specialOfferDesc; track validation) {
                      <mat-error>
                        @if (form1.get('specialOfferDesc').hasError(validation.type) &&
                        (form1.get('specialOfferDesc').dirty || form1.get('specialOfferDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>


                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Special Offers (OTA)</mat-label>
                      <textarea matInput formControlName="summaryDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter summaryDesc, paragraphs ok."></textarea>
                      @for (validation of validationMessages.summaryDesc; track validation) {
                      <mat-error>
                        @if (form1.get('summaryDesc').hasError(validation.type) && (form1.get('summaryDesc').dirty ||
                        form1.get('summaryDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Long Property Description </mat-label>
                      <textarea rows="10" matInput formControlName="propDesc" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="10" matAutosizeMaxRows="200"
                        matTooltip="Enter propDesc, paragraphs ok."></textarea>
                      @for (validation of validationMessages.propDesc; track validation) {
                      <mat-error>
                        @if (form1.get('propDesc').hasError(validation.type) && (form1.get('propDesc').dirty ||
                        form1.get('propDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field> @if (!formReadOnly) {
                    <span class="ai-label-link" (click)="openAiDialog('propDesc',2)">
                      AI
                    </span>
                    }
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Property Benefits</mat-label>
                      <textarea matInput formControlName="benefitsDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter benefitsDesc, paragraphs ok."></textarea>
                      @for (validation of validationMessages.benefitsDesc; track validation) {
                      <mat-error>
                        @if (form1.get('benefitsDesc').hasError(validation.type) && (form1.get('benefitsDesc').dirty ||
                        form1.get('benefitsDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Location Desccription</mat-label>
                      <textarea matInput formControlName="locationDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.locationDesc; track validation) {
                      <mat-error>
                        @if (form1.get('locationDesc').hasError(validation.type) && (form1.get('locationDesc').dirty ||
                        form1.get('locationDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Pets Desc</mat-label>
                      <textarea matInput formControlName="petsDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.petsDesc; track validation) {
                      <mat-error>
                        @if (form1.get('petsDesc').hasError(validation.type) && (form1.get('petsDesc').dirty ||
                        form1.get('petsDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Disabled Desc</mat-label>
                      <textarea matInput formControlName="disabledDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.disabledDesc; track validation) {
                      <mat-error>
                        @if (form1.get('disabledDesc').hasError(validation.type) && (form1.get('disabledDesc').dirty ||
                        form1.get('disabledDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Consumables Desc</mat-label>
                      <textarea matInput formControlName="consumablesDesc" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter description of amenities, ie Loccitane."></textarea>
                      @for (validation of validationMessages.consumablesDesc; track validation) {
                      <mat-error>
                        @if (form1.get('consumablesDesc').hasError(validation.type) &&
                        (form1.get('consumablesDesc').dirty || form1.get('consumablesDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Terms Desc (Printed terms in contract AND website AND
                        marketing.)</mat-label>
                      <textarea matInput formControlName="termsDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50" matTooltip="c"></textarea>
                      @for (validation of validationMessages.termsDesc; track validation) {
                      <mat-error>
                        @if (form1.get('termsDesc').hasError(validation.type) && (form1.get('termsDesc').dirty ||
                        form1.get('termsDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>



                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Contract Terms: Additional</mat-label>
                      <textarea matInput formControlName="contractTerms" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="15" matAutosizeMaxRows="500"
                        matTooltip="Enter contractTerms, paragrphs are ok.  Terms will be amended to guest contract ONLY - not in any marketing or other."></textarea>
                      @for (validation of validationMessages.contractTerms; track validation) {
                      <mat-error>
                        @if (form1.get('featureDesc').get('contractTerms').hasError(validation.type) &&
                        (form1.get('featureDesc').get('contractTerms').dirty ||
                        form1.get('featureDesc').get('contractTerms').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>


                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Maintenance Issues Desc</mat-label>
                      <textarea matInput formControlName="maintenanceIssuesDesc" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.maintenanceIssuesDesc; track validation) {
                      <mat-error>
                        @if (form1.get('maintenanceIssuesDesc').hasError(validation.type) &&
                        (form1.get('maintenanceIssuesDesc').dirty || form1.get('maintenanceIssuesDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Features Desc</mat-label>
                      <textarea matInput formControlName="featureDesc" readonly="{{formReadOnly}}" matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.featureDesc; track validation) {
                      <mat-error>
                        @if (form1.get('featureDesc').hasError(validation.type) && (form1.get('featureDesc').dirty ||
                        form1.get('featureDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Vacation Equipment Desc</mat-label>
                      <textarea matInput formControlName="vacationEquipmentDesc" readonly="{{formReadOnly}}"
                        matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                        matTooltip="Enter seo terms separated by commas."></textarea>
                      @for (validation of validationMessages.vacationEquipmentDesc; track validation) {
                      <mat-error>
                        @if (form1.get('vacationEquipmentDesc').hasError(validation.type) &&
                        (form1.get('vacationEquipmentDesc').dirty || form1.get('vacationEquipmentDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Website Headline - Default (WEBSITE SHORT HEADLINE, NOT USED YET)
                        <mat-hint>
                          (<code>{{headlineDefaultLength}}</code> of
                          <code>150</code> characters)
                        </mat-hint>
                      </mat-label>
                      <input matInput formControlName="headlineDefault" readonly="{{formReadOnly}}" maxlength="150">
                      @for (validation of validationMessages.headlineDefault; track validation) {
                      <mat-error>
                        @if (form1.get('headlineDefault').hasError(validation.type) &&
                        (form1.get('headlineDefault').dirty || form1.get('headlineDefault').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <mat-form-field class="w-100">
                      <mat-label>Website Headline - Special Offer (WEBSITE SHORT SPECIAL HEADLINE, NOT
                        USED YET)<mat-hint>
                          (<code>{{headlineSpecialOfferLength}}</code> of <code>150</code>
                          characters)
                        </mat-hint>
                      </mat-label>
                      <input matInput formControlName="headlineSpecialOffer" readonly="{{formReadOnly}}"
                        maxlength="150">

                      @for (validation of validationMessages.headlineSpecialOffer; track validation) {
                      <mat-error>
                        @if (form1.get('headlineSpecialOffer').hasError(validation.type) &&
                        (form1.get('headlineSpecialOffer').dirty || form1.get('headlineSpecialOffer').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                        }
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="subsection" id="section-marketing-rooms">
              <h3 class="subsection-title">Rooms</h3>
              <div class="marketing-rooms-subsections">
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-living">
                  <h4 class="subsection-title">Living</h4>
                  <br>
                  <div formGroupName="livingRoom" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Living Room</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Living Room</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list fxFlex="calc(100%-10px)" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="LV">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list fxFlex="calc(100%-10px)" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="LV">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-dining">
                  <h4 class="subsection-title">Dining</h4>
                  <div formGroupName="diningRoom" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Dining Room</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Dining Room</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="DN">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="DN">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-kitchen">
                  <h4 class="subsection-title">Kitchen</h4>
                  <div formGroupName="kitchen" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Kitchen</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Kitchen</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div><br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Kitchen"
                        [shortTermRentalId]="shortTermRentalId" featureType="kitchen" describesType="KN">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="KN">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="KN">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-bedrooms">
                  <h4 class="subsection-title">Bedrooms</h4>
                  <div formGroupName="featureDesc" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Bedroom Summary</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label> </mat-label>
                        <textarea matInput formControlName="bedroomSummary" readonly="{{formReadOnly}}"
                          matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="30"
                          matTooltip="Enter bedroomSummary, no paragraphs."></textarea>
                        @for (validation of validationMessages.bedroomSummary; track validation) {
                        <mat-error>
                          @if (form1.get('bedroomSummary').hasError(validation.type) &&
                          (form1.get('bedroomSummary').dirty || form1.get('bedroomSummary').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <div class="w-100">
                        @if (formAction.includes('edit')) {
                        <button style="float:right;" mat-raised-button color="primary" (click)="formUpdate()">Update
                          Description</button>
                        }
                      </div>
                    </div>
                  </div>
                  <br><br>
                  @if (true && !loadState.bedroom) {
                  <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                    (click)="loadComponent('bedroom')">Load
                    Bedrooms</button>
                  }
                  @if (loadState.bedroom) {
                  <app-bedroom [shortTermRentalId]="shortTermRentalId" [featuresList]="featuresList">
                  </app-bedroom>
                  }
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-bathrooms">
                  <h4 class="subsection-title">Bathrooms</h4>
                  <div formGroupName="featureDesc" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Bathroom Summary</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Bathrooms Summary</mat-label>
                        <textarea matInput formControlName="bathroomSummary" readonly="{{formReadOnly}}"
                          matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="30"
                          matTooltip="Enter bathroomSummary, no paragraphs."></textarea>
                        @for (validation of validationMessages.bathroomSummary; track validation) {
                        <mat-error>
                          @if (form1.get('bathroomSummary').hasError(validation.type) &&
                          (form1.get('bathroomSummary').dirty || form1.get('bathroomSummary').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <div class="w-100">
                        @if (formAction.includes('edit')) {
                        <button fxflex style="float:right;" mat-raised-button color="primary" (click)="formUpdate()"
                          [disabled]="!form1.valid">Update
                          Description
                        </button>
                        }
                      </div>
                    </div>
                  </div>
                  <br><br>
                  @if (true && !loadState.bathroom) {
                  <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                    (click)="loadComponent('bathroom')">Load
                    Bathrooms</button>
                  }
                  @if (loadState.bathroom) {
                  <app-bathroom [shortTermRentalId]="shortTermRentalId" [featuresList]="featuresList">
                  </app-bathroom>
                  }
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-den">
                  <h4 class="subsection-title">Den</h4>
                  <div class="row m-0">
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="DE">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="DE">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-family">
                  <h4 class="subsection-title">Family</h4>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Games"
                        [shortTermRentalId]="shortTermRentalId" featureType="games" describesType="FF">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="FF">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="FF">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-fitness">
                  <h4 class="subsection-title">Fitness</h4>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Fitness"
                        [shortTermRentalId]="shortTermRentalId" featureType="fitness" describesType="HL">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="HL">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="HL">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-mudroom">
                  <h4 class="subsection-title">Mudroom</h4>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="MUD">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes"
                        [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="MUD">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </div>
                <div class="nav-subsection nav-grandchild-target" id="marketing-rooms-balcony">
                  <h4 class="subsection-title">Balcony</h4>
                  <div formGroupName="balcony" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Balcony</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Balcony</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragraphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div><br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Location"
                        [shortTermRentalId]="shortTermRentalId" featureType="location" describesType="BY">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="View"
                        [shortTermRentalId]="shortTermRentalId" featureType="view" describesType="BY">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Outdoor"
                        [shortTermRentalId]="shortTermRentalId" featureType="outdoor" describesType="BY">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Rooms"
                        [shortTermRentalId]="shortTermRentalId" featureType="floorplan" describesType="BY">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Leisure"
                        [shortTermRentalId]="shortTermRentalId" featureType="leisure" describesType="BY">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </div>
              </div>



            </div>

            <div class="subsection" id="section-marketing-features">
              <h3 class="subsection-title">Features</h3>
              <!-- Features subsections flattened (replacing tabs) -->

              <div class="row m-0">
                <div class="col-lg-12">
                  <h3 class="w-100">Features</h3>
                </div>
                <div class="col-lg-12">
                  <mat-divider class="w-100"></mat-divider>
                </div>
                <div class="col-lg-12">
                  <div formGroupName="featureDesc" class="row m-0">
                    <div class="col-lg-3 col-md-6 col-lg-6">
                      <mat-slide-toggle class="w-100" formControlName="smoking">Smoking?
                      </mat-slide-toggle>
                    </div>
                    <div class="col-lg-3 col-md-6 col-lg-6">
                      <mat-slide-toggle class="w-100" formControlName="safe">Safe?
                      </mat-slide-toggle>
                    </div>
                    <div class="col-lg-3 col-md-6 col-lg-6">
                      <mat-slide-toggle class="w-100" formControlName="pets">Pets?
                      </mat-slide-toggle>
                    </div>
                    <div class="col-lg-3 col-md-6 col-lg-6">
                      <mat-slide-toggle class="w-100" formControlName="disabled">Handicapped?
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <mat-divider class="w-100"></mat-divider>
                </div>
              </div>

              <div class="marketing-features-subsections">

                <div id="marketing-features-access" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Access</h3>

                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Property Rank"
                        [shortTermRentalId]="shortTermRentalId" featureType="propertyCond" describesType="">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Property Access"
                        [shortTermRentalId]="shortTermRentalId" featureType="access" describesType="">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Handicapped Access"
                        [shortTermRentalId]="shortTermRentalId" featureType="ada" describesType="">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Arrival"
                        [shortTermRentalId]="shortTermRentalId" featureType="arrival" describesType="">
                      </app-feature-list>
                      }
                    </div>
                  </div>

                </div>

                <div id="marketing-features-exterior" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Exterior</h3>

                  <div formGroupName="exterior" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Exterior</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Exterior</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Outdoor"
                        [shortTermRentalId]="shortTermRentalId" featureType="outdoor" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Outdoor Feature"
                        [shortTermRentalId]="shortTermRentalId" featureType="outdoorFeature" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Outdoor Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="outdoorFurniture" describesType="">
                      </app-feature-list>
                      }
                    </div>
                    <br><br>
                  </div>

                </div>

                <div id="marketing-features-views" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Views</h3>

                  <div formGroupName="view" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">View</h3>
                    </div>
                    <div class="col-md-12 col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>View Type</mat-label>
                        <mat-select [(value)]="form1.value.viewType" formControlName="viewType">
                          @for (stat of viewTypes; track stat) {
                          <mat-option [value]="stat.value">
                            {{stat.name}}
                          </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.viewType; track validation) {
                        <mat-error>
                          @if (form1.get('view.viewType').hasError(validation.type) && (form1.get('view.viewType').dirty
                          || form1.get('view.viewType').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>View</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="View"
                        [shortTermRentalId]="shortTermRentalId" featureType="view" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-electronics" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Electronics</h3>

                  <div formGroupName="entertainment" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Entertainment</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Entertainment</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Channels"
                        [shortTermRentalId]="shortTermRentalId" featureType="tvChannels" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Players"
                        [shortTermRentalId]="shortTermRentalId" featureType="tvPlayers" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Service"
                        [shortTermRentalId]="shortTermRentalId" featureType="tvService" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Tv Type"
                        [shortTermRentalId]="shortTermRentalId" featureType="tvType" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Phone"
                        [shortTermRentalId]="shortTermRentalId" featureType="phone" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Music"
                        [shortTermRentalId]="shortTermRentalId" featureType="music" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Internet"
                        [shortTermRentalId]="shortTermRentalId" featureType="internet" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Computer"
                        [shortTermRentalId]="shortTermRentalId" featureType="computer" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-laundry" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Laundry</h3>

                  <div formGroupName="laundry" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Laundry</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Laundry</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div><br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Laundry"
                        [shortTermRentalId]="shortTermRentalId" featureType="laundry" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-hvac" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">HVAC</h3>

                  <div formGroupName="hvac" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Heating & Cooling</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>HVAC</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div><br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="HVAC"
                        [shortTermRentalId]="shortTermRentalId" featureType="hvac" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="HVAC Type"
                        [shortTermRentalId]="shortTermRentalId" featureType="hvacType" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-linen" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Linen</h3>

                  <div formGroupName="linen" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Linens</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Linens</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Linens"
                        [shortTermRentalId]="shortTermRentalId" featureType="linens" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-parking" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Parking</h3>

                  <div formGroupName="parking" class="row wrap m-0">
                    <br><br>
                    <div class="col-lg-12">
                      <mat-slide-toggle class="w-100" formControlName="parking">Parking
                      </mat-slide-toggle>
                    </div>
                    <div class="col-lg-12">
                      <h3 class="w-100">Parking Spaces</h3>
                    </div>
                    <div class="col-md-12 col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label># Garaged Spaces</mat-label>
                        <input matInput formControlName="parkingSpacesGaraged" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.parkingSpacesGaraged; track validation) {
                        <mat-error>
                          @if (form1.get('parkingSpacesGaraged').hasError(validation.type) &&
                          (form1.get('parkingSpacesGaraged').dirty || form1.get('parkingSpacesGaraged').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label># Parking Spaces Total (including garaged)</mat-label>
                        <input matInput formControlName="parkingSpacesTotal" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.parkingSpacesTotal; track validation) {
                        <mat-error>
                          @if (form1.get('parkingSpacesTotal').hasError(validation.type) &&
                          (form1.get('parkingSpacesTotal').dirty || form1.get('parkingSpacesTotal').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <h3 class="w-100">Parking Description</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Parking Desc</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <h3 class="w-100">Parking Fees</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Parking Fee</mat-label>
                        <input matInput formControlName="parkingFee" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.parkingFee; track validation) {
                        <mat-error>
                          @if (form1.get('parkingFee').hasError(validation.type) && (form1.get('parkingFee').dirty ||
                          form1.get('parkingFee').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <h3 class="w-100">Parking Fee Desc</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Parking Desc</mat-label>
                        <textarea matInput formControlName="parkingFeeDesc" readonly="{{formReadOnly}}"
                          matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter parkingFeeDesc, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.parkingFeeDesc; track validation) {
                        <mat-error>
                          @if (form1.get('parkingFeeDesc').hasError(validation.type) &&
                          (form1.get('parkingFeeDesc').dirty || form1.get('parkingFeeDesc').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Parking"
                        [shortTermRentalId]="shortTermRentalId" featureType="parking" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                  </div>

                </div>

                <div id="marketing-features-children" class="nav-grandchild-target">

                  <h3 class="property-subsection-title">Children</h3>

                  <div formGroupName="children" class="row wrap m-0">
                    <div class="col-lg-12">
                      <h3 class="w-100">Children</h3>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Children</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
                          matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                        <mat-error>
                          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty ||
                          form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                          }
                        </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <br><br>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Child Amenities"
                        [shortTermRentalId]="shortTermRentalId" featureType="childAmenity" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Children"
                        [shortTermRentalId]="shortTermRentalId" featureType="children" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <div class="subsection" id="section-marketing-floorplan">
              <h3 class="subsection-title">Floorplan</h3>
              <div class="row m-0">
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Floorplan"
                    [shortTermRentalId]="shortTermRentalId" featureType="floorplan" describesType="">
                  </app-feature-list>
                  }
                  <br><br>
                </div>
              </div>
            </div>

            <div class="subsection" id="section-marketing-amenities">
              <h3 class="subsection-title">Amenities</h3>
              <div class="row m-0">
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Room Amenities"
                    [shortTermRentalId]="shortTermRentalId" featureType="roomAmenity" describesType="">
                  </app-feature-list>
                  }<br><br>
                </div>
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Leisure"
                    [shortTermRentalId]="shortTermRentalId" featureType="leisure" describesType="">
                  </app-feature-list>
                  }
                  <br><br>
                </div>
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Green"
                    [shortTermRentalId]="shortTermRentalId" featureType="green" describesType="">
                  </app-feature-list>
                  }
                  <br><br>
                </div>
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Cleaning"
                    [shortTermRentalId]="shortTermRentalId" featureType="cleaning" describesType="">
                  </app-feature-list>
                  }
                  <br><br>
                </div>
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Housekeeping"
                    [shortTermRentalId]="shortTermRentalId" featureType="housekeeping" describesType="">
                  </app-feature-list>
                  }<br><br>
                </div>
                <div class="col-lg-12">
                  @if (featureListsLoaded) {
                  <app-feature-list class="w-100" [featuresList]="featuresList" title="Comfort"
                    [shortTermRentalId]="shortTermRentalId" featureType="comfort" describesType="">
                  </app-feature-list>
                  }
                  <br><br>
                </div>
              </div>
            </div>

            <div class="subsection" id="section-marketing-overrides">
              <h3 class="subsection-title">Overrides</h3>
              <mat-tab-group [(selectedIndex)]="ratesYieldSelectedIndex">
                <mat-tab label="Property">
                  <div class="row m-0">
                    <br>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList"
                        title="Property Type (select ONE only)" [shortTermRentalId]="shortTermRentalId"
                        featureType="propertyType" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Location"
                        [shortTermRentalId]="shortTermRentalId" featureType="location" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Style"
                        [shortTermRentalId]="shortTermRentalId" featureType="style" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Theme"
                        [shortTermRentalId]="shortTermRentalId" featureType="theme" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Rules"
                        [shortTermRentalId]="shortTermRentalId" featureType="rules" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Safety"
                        [shortTermRentalId]="shortTermRentalId" featureType="safety" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Pets"
                        [shortTermRentalId]="shortTermRentalId" featureType="pets" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Green Things"
                        [shortTermRentalId]="shortTermRentalId" featureType="green" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Language"
                        [shortTermRentalId]="shortTermRentalId" featureType="language" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Currency"
                        [shortTermRentalId]="shortTermRentalId" featureType="currency" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Concierge">
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Onsite In Resort/Complex"
                        [shortTermRentalId]="shortTermRentalId" featureType="onsite" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Business"
                        [shortTermRentalId]="shortTermRentalId" featureType="business" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Concierge"
                        [shortTermRentalId]="shortTermRentalId" featureType="concierge" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Entertainment"
                        [shortTermRentalId]="shortTermRentalId" featureType="entertainment" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Transport"
                        [shortTermRentalId]="shortTermRentalId" featureType="transport" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Transport Shuttle"
                        [shortTermRentalId]="shortTermRentalId" featureType="transportShuttle" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Fitness & Spa">
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Fitness"
                        [shortTermRentalId]="shortTermRentalId" featureType="fitness" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Spa"
                        [shortTermRentalId]="shortTermRentalId" featureType="spa" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Pool & Hotubs">
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Pool Type"
                        [shortTermRentalId]="shortTermRentalId" featureType="poolType" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Pool"
                        [shortTermRentalId]="shortTermRentalId" featureType="pool" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Pool Features"
                        [shortTermRentalId]="shortTermRentalId" featureType="poolFeatures" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Pool Furniture"
                        [shortTermRentalId]="shortTermRentalId" featureType="poolFurniture" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Nearby">
                  <div class="row m-0">
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Nearby"
                        [shortTermRentalId]="shortTermRentalId" featureType="nearby" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Rentals"
                        [shortTermRentalId]="shortTermRentalId" featureType="rentals" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Restaurants"
                        [shortTermRentalId]="shortTermRentalId" featureType="restaurant" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Sports"
                        [shortTermRentalId]="shortTermRentalId" featureType="sports" describesType="">
                      </app-feature-list>
                      }
                      <br><br>
                    </div>
                    <div class="col-lg-12">
                      @if (featureListsLoaded) {
                      <app-feature-list class="w-100" [featuresList]="featuresList" title="Tours"
                        [shortTermRentalId]="shortTermRentalId" featureType="tours" describesType="">
                      </app-feature-list>
                      }<br><br>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div class="subsection" id="section-marketing-media">
              <h3 class="subsection-title">Media</h3>
              @if (true && !loadState.pictures) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('pictures')">Load
                Pictures</button>
              }
              @if (loadState.pictures) {
              <app-property-image-vert-layout [shortTermRentalId]="shortTermRentalId">
              </app-property-image-vert-layout>
              }
            </div>

          </section>

          <section id="section-reviews" class="jump-section">
            <h2 class="section-header">Reviews</h2>

            @if (true && !loadState.reviews) {
            <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
              (click)="loadComponent('reviews')">Load Reviews</button>
            }
            @if (loadState.reviews) {
            <app-review-list [shortTermRentalId]="shortTermRentalId" [propertyCode]="form1.value.propertyCode">
            </app-review-list>
            }

          </section>

          <section id="section-rates-yield" class="jump-section">
            <h2 class="section-header">Rates & Yield</h2>

            <div class="subsection" id="section-rates-yield-property">
              <h3 class="subsection-title">YieldMax Property</h3>
              @if (!loadState.yieldMaxProperties) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('yieldMaxProperties')">Load YieldMax Properties</button>
              }
              @if (yieldMaxPropertyId && loadState.yieldMaxProperties) {
              <app-properties [propertyId]="yieldMaxPropertyId"></app-properties>
              }
              @if (!yieldMaxPropertyId && loadState.yieldMaxProperties) {
              <p class="text-muted small">This property is not linked to a YieldMax record.</p>
              }
            </div>

            <div class="subsection" id="section-rates-yield-reservation">
              <h3 class="subsection-title">Reservation</h3>
              @if (!loadState.yieldMaxReservations) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('yieldMaxReservations')">Load YieldMax Reservations</button>
              }
              @if (yieldMaxPropertyId && loadState.yieldMaxReservations) {
              <app-reservations-list [titleFontSize]="true" [propertyId]="yieldMaxPropertyId"></app-reservations-list>
              }
            </div>

            <div class="subsection" id="section-rates-yield-setting">
              <h3 class="subsection-title">Setting</h3>
              @if (!loadState.yieldMaxProperties) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('yieldMaxProperties')">Load YieldMax Properties</button>
              }
              @if (yieldMaxPropertyId && loadState.yieldMaxProperties) {
              <app-properties [showFields]="true" [propertyId]="yieldMaxPropertyId"></app-properties>
              }
            </div>

            <div class="subsection" id="section-rates-yield-rate">
              <h3 class="subsection-title">Rate</h3>
              @if (!loadState.tapeChart) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('tapeChart')">Load Tape Chart</button>
              }
              @if (yieldMaxPropertyId && loadState.tapeChart) {
              <app-tape-chart-list [titleFontSize]="true" [propertyId]="yieldMaxPropertyId"></app-tape-chart-list>
              }
            </div>

            <div class="subsection" id="section-rates-yield-seasons">
              <h3 class="subsection-title">Seasons</h3>
              @if (!loadState.rateSeason) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('rateSeason')">Load Rate Seasons</button>
              }
              @if (yieldMaxRateBucketId && loadState.rateSeason) {
              <app-rateSeason-list [titleFontSize]="true" [rateBucketId]="yieldMaxRateBucketId"></app-rateSeason-list>
              }
            </div>

            <div class="subsection" id="section-rates-yield-quality-test">
              <h3 class="subsection-title">Quality Test</h3>
              @if (!loadState.qualityTests) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('qualityTests')">Load Quality Tests</button>
              }
              @if (yieldMaxPropertyId && loadState.qualityTests) {
              <app-quality-test-list [propertyId]="yieldMaxPropertyId"></app-quality-test-list>
              }
            </div>

            @if (yieldMaxPropertyId) {
            <div class="subsection" id="section-rates-yield-history">
              <h3 class="subsection-title">History</h3>
              @if (!loadState.auditList) {
              <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
                (click)="loadComponent('auditList')">Load Audit List</button>
              }
              @if (yieldMaxPropertyId && loadState.auditList) {
              <app-audit-list [source]="'YM'"
                [auditUrl]="'properties/' + yieldMaxPropertyId + '/audit'"></app-audit-list>
              }
            </div>
            }
            <!-- <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn" *ngIf="true && !loadState.rateOverride" (click)="loadComponent('rateOverride')">Load Rate Override</button>
                                                                                                            <app-rate-override *ngIf="loadState.rateOverride" (shortTermRentalId)=shortTermRentalId></app-rate-override> -->

          </section>

          <section id="section-admin" class="jump-section">
            <h2 class="section-header">Admin</h2>


            @if (true && !loadState.propertyAdmin) {
            <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
              (click)="loadComponent('propertyAdmin')">Load Property
              Admin</button>
            }
            @if (loadState.propertyAdmin) {
            <app-property-admin [shortTermRentalId]="shortTermRentalId"></app-property-admin>
            }
            <div class="wrap align-items-center" style="padding: 10px;">
              <button pButton type="button" style="padding: 10px;" label="Flush property from VRBO"
                class="p-button-outlined" (click)="flusPropertyFromVRBO()"></button>
              <button pButton type="button" style="padding: 10px; margin-left: 10px;" label="Refresh Property Cache"
                class="p-button-outlined" (click)="refreshPropertyCache()"></button>
              <mat-form-field [formGroup]="copyFeaturesFromPropertyForm" class="w-100">

                <mat-label>Copy From Property</mat-label>

                <!-- <mat-select (selectionChange)="onCopyFeaturesFromProperty($event)" formControlName="destShortTermRentalId"> -->

                <mat-select formControlName="srcShortTermRentalId">
                  @for (property of properties; track property) {
                  <mat-option [value]="property.shortTermRentalId">
                    {{property.propertyCode}} </mat-option>
                  }
                </mat-select>


                @for (validation of validationMessages.listingStatus; track validation) {
                <mat-error>
                  @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty ||
                  form1.get('listingStatus').touched)) {
                  <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
                }

              </mat-form-field>
              <div style="margin-left:15px;">
                <button mat-button matSuffix mat-stroked-button color="warning"
                  (click)="onCopyFeaturesFromProperty()">Copy
                  Features</button>
              </div>
            </div>
            <div class="wrap align-items-center" style="padding:30px;">
              <mat-form-field [formGroup]="mergeFeaturesFromPropertyForm" class="w-100">
                <mat-label>Merge From Property</mat-label>
                <!-- <mat-select (selectionChange)="onCopyFeaturesFromProperty($event)" formControlName="destShortTermRentalId"> -->
                <mat-select formControlName="srcShortTermRentalId">
                  @for (property of properties; track property) {
                  <mat-option [value]="property.shortTermRentalId">
                    {{property.propertyCode}} </mat-option>
                  }
                </mat-select>
                @for (validation of validationMessages.listingStatus; track validation) {
                <mat-error>
                  @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty ||
                  form1.get('listingStatus').touched)) {
                  <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
              <div style="margin-left:15px;">
                <button mat-button matSuffix mat-stroked-button color="warning"
                  (click)="onMergeFeaturesFromProperty()">Merge
                  Features</button>
              </div>
            </div>

          </section>

          <section id="section-quality" class="jump-section">
            <h2 class="section-header">Quality</h2>

            @if (true && !loadState.listingQualityStatus) {
            <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
              (click)="loadComponent('listingQualityStatus')">Load Listing Quality Status</button>
            }
            @if (loadState.listingQualityStatus) {
            <app-listing-quality-status-list [shortTermRentalId]="shortTermRentalId">
            </app-listing-quality-status-list>
            }

          </section>

          <section id="section-history-enriched" class="jump-section">
            <h2 class="section-header">History-Enriched</h2>

            @if (true && !loadState.auditEnriched) {
            <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
              (click)="loadComponent('auditEnriched')">Load Audit
              History</button>
            }
            @if (loadState.auditEnriched) {
            <app-audit-enriched-list
              [auditUrl]="'properties/' + this.shortTermRentalId + '/audit-full-history'"></app-audit-enriched-list>
            }

          </section>

          @if (shortTermRentalId) {
          <section id="section-tasks" class="jump-section">
            <h2 class="section-header">Tasks</h2>
            @if (true && !loadState.publicTaskList) {
            <button type="button" class="btn btn-outline-secondary btn-sm lazy-load-btn"
              (click)="loadComponent('publicTaskList')">Load Public
              Tasks</button>
            }
            @if (loadState.publicTaskList) {
            <app-public-task-list [popupMode]="false" [taskSource]="9" [showFilter]="true"
              [passedTaskName]="'Property: '+property?.propertyCode"
              [taskSourceId]="shortTermRentalId"></app-public-task-list>
            }
          </section>
          }
        </main>
      </div>

    </div>
  </form>
  @if (formAction.includes('edit')) {
  <div class="floating-update">
    <button mat-raised-button color="primary" (click)="formUpdate()">Update</button>
  </div>
  }
  <br>
  <div style="float:right; padding-right: 70px;">
    @if (formAction.includes('add')) {
    <button mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Submit</button>
    }
    @if (formAction.includes('add')) {
    <button mat-button type="reset" (click)="this.form1.reset()">Clear</button>
    }
    @if (formAction.includes('add')) {
    <button mat-button type="button" (click)="routerLocation.back()">Cancel</button>
    }

    @if (formAction.includes('edit') && !isRateAndYMTabSelected) {
    <button mat-raised-button color="primary" (click)="formUpdate()">Update</button>
    }
    @if (formAction.includes('edit')) {
    <button mat-button type="button" [routerLink]="['/property-view', form1.value.propertyId]">Cancel</button>
    }

    @if (formAction.includes('view')) {
    <button mat-raised-button color="primary" [routerLink]="['/property-edit', form1.value.propertyId]">Edit</button>
    }
    @if (formAction.includes('view')) {
    <button mat-button type="button" [routerLink]="['/property-list']">Done</button>
    }
    @if (formLoading) {
    <img class="pl-3"
      src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    }
  </div>

  <!-- Show AI Trip Planner -->
  <p-dialog [(visible)]="showAiDialog" [modal]="true" [closable]="true" (onHide)="onDialogHide()">
    <!--<ai-dialog [aiAgentId]="aiTargetAgentId" (copyResponse)="onCopyResponse($event)" (close)="showAiDialog = false"></ai-dialog> -->
  </p-dialog>
</div>
